import { render } from "./Notification.vue?vue&type=template&id=9084a0ca&scoped=true"
import script from "./Notification.vue?vue&type=script&setup=true&lang=js"
export * from "./Notification.vue?vue&type=script&setup=true&lang=js"

import "./Notification.vue?vue&type=style&index=0&id=9084a0ca&lang=scss&scoped=true"

import exportComponent from "/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9084a0ca"],['__file',"src/components/Notification.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "9084a0ca"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('9084a0ca', __exports__)) {
    console.log('reload')
    api.reload('9084a0ca', __exports__)
  }
  
  module.hot.accept("./Notification.vue?vue&type=template&id=9084a0ca&scoped=true", () => {
    console.log('re-render')
    api.rerender('9084a0ca', render)
  })

}


export default __exports__